<template>
     <v-dialog
      v-model="dialog"
      max-width="500"
      persistent
    >
       <v-card>
        <v-toolbar flat dense cad color="info" dark>
            <v-toolbar-title class="subheading text-xs-center">Confirm Sign Off</v-toolbar-title>
            <v-spacer></v-spacer>
		</v-toolbar>

        <v-card-text class="py-5">
            <p class="mb-4">Are you sure you want to sign off on your answers?</p>
            <v-alert class="font-italic mb-0 text-xs-left" :value="true" type="info" outline>By signing off you are acknowledging that you are happy with your answers. These answers will be made available as discussion points in the discussion phase of the review. These answers can be changed before the discussion date, but you will need to sign off on them again.</v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn flat @click="onCancelClicked">Cancel</v-btn>
            <v-btn color="primary" flat @click="onSignOffClicked">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        dialog: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        onSignOffClicked() {
            this.$emit('onSignOff');
        },
        onCancelClicked() {
            this.$emit('onCancel');
        }
    }
}
</script>